import IncomingCallBanner from "./IncomingCallBanner";

export default IncomingCallBanner;
